import { Controller } from "@hotwired/stimulus"

// Panel de suggestions d'aptitudes IA : désactive le bouton « valider » tant
// qu'aucune suggestion n'est cochée. Le panel fonctionne sans JS (soumission
// classique) — ce controller n'est qu'une amélioration progressive.
export default class extends Controller {
  static targets = ["checkbox", "submit"]

  connect() {
    this.refresh()
  }

  refresh() {
    if (!this.hasSubmitTarget) return

    const anyChecked = this.checkboxTargets.some((box) => box.checked)
    this.submitTarget.disabled = !anyChecked
  }
}
